<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-22 10:07:22
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-27 11:37:13
 * @name: 填写费用
 * @Description: 填写费用
 * @FilePath: \project\src\components\afterSale\dialog-fee-sign.vue
 * @Author: desktop
-->
<template>
  <el-dialog
    width="80%"
    append-to-body
    title="填写金额"
    :visible.sync="show"
    @close="close"
  >
    <div class="container">
      <div class="row" v-if="needSelect.includes('need_pay')">
        <font class="label">是否需要费用</font>
        <div class="value">
          <el-radio-group v-model="need_pay">
            <el-radio
              :label="item.value"
              v-for="item of need_pays"
              :key="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="row" v-if="has_pay_user && needSelect.includes('pay_user')">
        <font class="label">费用收取对象</font>
        <div class="value">
          <el-radio-group v-model="pay_user">
            <el-radio
              :label="item.value"
              v-for="item of pay_users"
              :key="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <template v-if="has_fee">
        <div class="part">
          <font class="title">部件</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'parts_fee'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}</font>
                  <el-input
                    class="input"
                    size="mini"
                    v-model="item.value"
                    @blur="
                      () => {
                        !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                          item.value
                        ) && (item.value = 0);
                      }
                    "
                  ></el-input>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注</font>
                  <el-input
                    class="textarea"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入备注..."
                    v-model="item.value"
                  ></el-input>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">工资</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'salary'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}</font>
                  <el-input
                    class="input"
                    size="mini"
                    v-model="item.value"
                    @blur="
                      () => {
                        !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                          item.value
                        ) && (item.value = 0);
                      }
                    "
                  ></el-input>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注</font>
                  <el-input
                    class="textarea"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入备注..."
                    v-model="item.value"
                  ></el-input>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">运费</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'trans_port'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}</font>
                  <el-input
                    class="input"
                    size="mini"
                    v-model="item.value"
                    @blur="
                      () => {
                        !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                          item.value
                        ) && (item.value = 0);
                      }
                    "
                  ></el-input>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注</font>
                  <el-input
                    class="textarea"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入备注..."
                    v-model="item.value"
                  ></el-input>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">其它</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'others'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}</font>
                  <el-input
                    class="input"
                    size="mini"
                    v-model="item.value"
                    @blur="
                      () => {
                        !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                          item.value
                        ) && (item.value = 0);
                      }
                    "
                  ></el-input>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注</font>
                  <el-input
                    class="textarea"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入备注..."
                    v-model="item.value"
                  ></el-input>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="sum">
          <font>总计：{{ totalFee }}元</font>
        </div>
      </template>
      <div class="btn-group">
        <el-button size="mini" @click="show = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { origin_fee, need_pays, pay_users } from "@/config/issue.config";
import { debounceation } from "@/utils/decorator";
import issueService from "@/module/issue/issue.service";
const origin_need_pay = 1;
const origin_pay_user = 1;
export default {
  props: {
    needSelect: {
      type: Array,
      default: () => ["need_pay", "pay_user"],
    },
    origin: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      issueService: new issueService(),
      show: false,
      issue_name: "", //处理方式
      need_pay: 1, //选择的是否需要费用 1是 0否
      pay_users, //费用收取对象
      pay_user: 1, //选择的费用收取对象
      fee: [], //费用信息
    };
  },
  computed: {
    // 是否需要费用
    need_pays() {
      return need_pays.filter((x) => x.value !== 2);
    },
    // 费用总计
    totalFee() {
      let fees = this.fee;
      let totalFee = 0;
      for (let x of fees) {
        if (x.type === "fee") {
          totalFee = Number(totalFee) + Number(x.value);
        }
      }
      return totalFee;
    },
    // 存在费用收取对象
    has_pay_user() {
      return this.issue_name === "货损" && Number(this.need_pay) === 1;
    },
    // 存在费用
    has_fee() {
      return Number(this.need_pay === 1) && Number(this.pay_user) === 1;
    },
  },
  watch: {
    need_pay: {
      handler(nv, ov) {
        this.pay_user = JSON.parse(JSON.stringify(origin_pay_user));
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} fee 原始金额信息
     */
    open(fee) {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          this.issue_name = res.data.issue_name;
          this.need_pay = this.origin?.need_pay ?? 1;
          this.pay_user = this.origin?.pay_user ?? 1;
          this.fee = fee
            ? JSON.parse(JSON.stringify(fee))
            : JSON.parse(JSON.stringify(origin_fee));
          this.show = true;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    confirm() {
      this.$emit("feeSignConfirm", {
        need_pay: this.need_pay,
        pay_user: this.pay_user,
        fee: this.fee,
      });
      this.show = false;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.fee = JSON.parse(JSON.stringify(origin_fee));
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    margin: 10px 0;
    padding: 10px 0;
    @extend .et-flex-start;
    font-size: $Vars-font-content-size;
    .label {
      flex-shrink: 0;
      margin-right: 40px;
      text-align: right;
    }
    .value {
      flex: 1;
      @extend .et-flex-normal;
    }
  }
  .part {
    width: 100%;
    padding: 10px 0;
    @extend .et-flex-column-normal;
    .title {
      font-size: $Vars-font-miniTitle-size;
      font-weight: bold;
      color: $Vars-font-important-color;
      padding-bottom: 10px;
    }
    .fees {
      padding: 10px 0;
      width: 100%;
      @extend .et-flex-normal;
      .fee {
        width: 25%;
        box-sizing: border-box;
        padding: 5px 10px;
        @extend .et-flex-start;
        font-size: $Vars-font-content-size;
        .label {
          min-width: calc(#{$Vars-font-content-size} * 4);
          margin-right: 10px;
          text-align: right;
        }
        .input {
          flex: 1;
          /deep/ input {
            text-align: right;
          }
        }
      }
      .remark {
        margin: 10px 0;
        width: 100%;
        box-sizing: border-box;
        padding: 5px 10px;
        @extend .et-flex-normal;
        .label {
          min-width: calc(#{$Vars-font-content-size} * 4);
          margin-right: 10px;
          text-align: right;
        }
        .textarea {
          width: 300px;
        }
      }
    }
  }
  .sum {
    margin: 10px 0;
    width: 100%;
    font-size: $Vars-font-miniTitle-size;
    font-weight: bold;
    color: $Vars-font-important-color;
  }
  .btn-group {
    margin: 20px 0;
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>